import type { IconSvgObject } from './types';

const FolderFileStorageIcon: IconSvgObject = [
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.7071 15.2071L19.7929 13.2929C19.6054 13.1054 19.351 13 19.0858 13H16C15.4477 13 15 13.4477 15 14V20C15 20.5523 15.4477 21 16 21H21C21.5523 21 22 20.5523 22 20V15.9142C22 15.649 21.8946 15.3946 21.7071 15.2071Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderFileStorageIcon;
